import { Components } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

type MenuProps = Components<Omit<Theme, 'components'>>['MuiMenu'];

const getMuiMenu = (): MenuProps => ({
  styleOverrides: {
    paper: ({ theme }: { theme: Theme }) => ({
      // border: "1px solid",
      borderColor: theme.palette.semantic.interactive.surface.border.default,
      boxShadow: '0px 3px 5px rgb(0, 0, 0, 0.15)',
      minWidth: 176,
      padding: 0,
      marginTop: '2px !important',
    }),
    list: {
      padding: 0,
    },
  },
  defaultProps: {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
    autoFocus: false,
  },
});
export default getMuiMenu;
